var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4799_7585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0605 9.08594H4.25349C3.61149 9.08594 3.02424 9.3975 2.71895 9.86896C2.55781 10.0704 2.43569 10.3272 2.37464 10.5953L0.363007 19.6194C0.235218 20.196 0.373062 20.7908 0.741906 21.2509C1.112 21.7122 1.66337 21.9766 2.25566 21.9766H18.0494C18.9514 21.9766 19.747 21.3416 19.9415 20.4666L21.9525 11.4432C21.9531 11.4425 21.9531 11.4425 21.9531 11.4425C22.2217 10.2293 21.298 9.08594 20.0605 9.08594Z",
    fill: "#D2042D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2792 4.07866L11.4135 0.213059C11.2934 0.0926173 11.0568 0.0234375 10.957 0.0234375H4.51172C4.15547 0.0234375 3.86719 0.311715 3.86719 0.66797V7.8008C8.22354 7.8008 11.0606 7.8008 15.4688 7.8008V4.53517C15.4688 4.42018 15.3957 4.19489 15.2792 4.07866ZM12.2461 6.46876H7.08985C6.7336 6.46876 6.44532 6.18048 6.44532 5.82423C6.44532 5.46798 6.7336 5.1797 7.08985 5.1797H10.957H12.2461C12.6024 5.1797 12.8906 5.46798 12.8906 5.82423C12.8906 6.18048 12.6024 6.46876 12.2461 6.46876ZM11.6016 3.89063V2.22391L13.2683 3.89063H11.6016Z",
    fill: "#D2042D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9336 3.92969C0.867369 3.92969 0 4.79706 0 5.86328V15.3246L1.11659 10.3146C1.21731 9.87146 1.40929 9.45922 1.67303 9.11366C1.90507 8.77348 2.22355 8.50359 2.57813 8.28604V3.92969H1.9336Z",
    fill: "#D2042D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4023 5.21875H16.7578V7.79688H19.3359V7.15235C19.3359 6.08612 18.4686 5.21875 17.4023 5.21875Z",
    fill: "#D2042D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4799_7585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.9d1fe563c2c2f193478f5b576b1b9ac0.svg";
export { ForwardRef as ReactComponent };